export class ComProductDealerModel {
    public commission?:number;
    public commissionShared?:number;
    public dealerEmployeeJobId?:number;
    public dealerId?:number;
    public employeeJobId?:number;
    public paymentId?:number;
    public productosCOEId?:number;
    
    public activeId?:boolean;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}